module.exports = "/_next/static/images/down-arrow-fb1473852f8c54485fa4bb993e94f855.svg";